import { appApis } from "../constants";
import reduxKeys from "../constants/reduxKeys";
import { normalizeCompany } from "../utils";
import HttpClient from "./http-client";


export const companiesApi = () => {
    return new HttpClient().get(appApis.companies);
}

export const addCompany = (postBody) => {
    return new HttpClient().post(appApis.companies, postBody);
}

export const updateCompany = (postBody, companyId) => {
    return new HttpClient().put(`${appApis.companies}/${companyId}`, postBody);
}

export const getCompanies = (stopLoading) => {
    return (dispatch) => {
        companiesApi().then(response => {
            if(response?.data?.data?.companies){
                const companies = (response?.data?.data?.companies || []).map(normalizeCompany);
                dispatch({ type: reduxKeys.SET_COMPANIES, payload: {
                    companies,
                    total: response?.data?.data?.total || 0,
                } });
            }
        }).catch(ex => {
            dispatch({
                type: reduxKeys.SET_COMPANIES, payload: {
                    companies: [],
                    total: 0,
                }
            });
        }).finally(() => {
            setTimeout(() => {
                if(stopLoading) stopLoading();
            }, stopLoading ? 500 : 10)
        })
    }
}

export const getCompanyRqTypes = () => {
    return (dispatch) =>{
        new HttpClient().get(appApis.companiesRqType).then(response => {
            dispatch({ type: reduxKeys.SET_COMPANY_REQUEST_TYPE, payload: response?.data?.data?.requestTypes ?? []})
        }).catch(ex => {})
    }
}

export const addCompanyRequest = (payload, reqId) => {
    return reqId ? new HttpClient().put(`${appApis.updateRequest}?id=${reqId}`, payload) : new HttpClient().post(`${appApis.createRequest}`, payload);
}

export const getCompaniesRq = (query = "") => {
    return new HttpClient().get(`${appApis.companiesRequest}${query}`);
}